import { z } from 'zod';
/** A person's authority inside an installer company. This deliberately is not a
 * public.memberships role: every person remains installer_external and can
 * never use this value to become Artemis staff. */
export const InstallerTeamRole = z.enum(['manager', 'worker']);
export const InstallerTeamPermission = z.enum([
    'company_work.read', 'company_finance.read', 'team.manage', 'team.assign',
    'assigned_work.read', 'work.report',
]);
export const INSTALLER_TEAM_PERMISSIONS = {
    manager: ['company_work.read', 'company_finance.read', 'team.manage', 'team.assign', 'assigned_work.read', 'work.report'],
    worker: ['assigned_work.read', 'work.report'],
};
export const InstallerTeamMember = z.object({
    user_id: z.string().uuid(), party_id: z.string().min(1), display_name: z.string().min(1),
    team_role: InstallerTeamRole, preferred_language: z.enum(['en', 'zh']), active: z.boolean(),
    can_install: z.boolean(),
    phone: z.string().nullable(), email: z.string().email().nullable(),
});
//# sourceMappingURL=installer-team.js.map